import React from 'react';
import { Settings, Clock, Lock, SlidersHorizontal, GraduationCap, BookOpenCheck, ChartBarStacked } from 'lucide-react';

export default function RightSidebar({ activeTab, setActiveTab }) {
  const navItems = [
    { id: 'general', label: 'General Information', icon: Settings },
    { id: 'academic', label: 'Academic Calendar', icon: GraduationCap },
    { id: 'grade', label: 'Academic Grade Standard', icon: BookOpenCheck },
    { id: 'category', label: 'Academic Grade Category', icon: ChartBarStacked },
    { id: 'attendance', label: 'Attendance Rules', icon: Clock },
    { id: 'leave', label: 'Leave Rules', icon: SlidersHorizontal },
    { id: 'security', label: 'Access Permissions', icon: Lock },
  ];
  return (
    <div className="lg:col-span-4 sticky top-0">
      <div className="bg-white border border-zinc-200 rounded-lg p-4 shadow-sm space-y-2">
        <h2 className="text-[11px] font-bold text-zinc-400 uppercase tracking-wider px-2 pb-2 border-b border-zinc-100">
          Configuration Navigation
        </h2>

        <div className="space-y-1 pt-1">
          {navItems.map((item) => {
            const Icon = item.icon;
            const isActive = activeTab === item.id;
            return (
              <button
                key={item.id}
                type="button"
                onClick={() => setActiveTab(item.id)}
                className={`w-full flex items-center gap-3 px-3 py-2.5 rounded-lg text-xs font-semibold transition-all cursor-pointer ${
                  isActive
                    ? 'bg-blue-50 text-blue-700 border border-blue-200 shadow-xs'
                    : 'text-zinc-600 border border-transparent hover:bg-zinc-50 hover:text-zinc-900'
                }`}
              >
                <Icon className={`w-4 h-4 shrink-0 ${isActive ? 'text-blue-600' : 'text-zinc-400'}`} />
                <span>{item.label}</span>
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
}